import { createSelector } from '@ngrx/store';
import { selectIngredientState } from '../reducers';
import { IngredientState } from '../reducers/ingredient.reducer';

export const getIngredientsTableState = createSelector(
  selectIngredientState,
  (state: IngredientState) => { return { total: state.total, currentPage: state.currentPage, perPage: state.perPage, order: state.order, direction: state.direction, filters: state.filters, includes: state.includes } }
);

export const getIngredients = createSelector(
    selectIngredientState,
    (state: IngredientState) => state.list
);

export const getTotalIngredients = createSelector(
  getIngredientsTableState,
  (tableState) => tableState.total
);

export const getIngredientsCurrentPage = createSelector(
  getIngredientsTableState,
  (tableState) => tableState.currentPage
);

export const getIngredientsPerPage = createSelector(
  getIngredientsTableState,
  (tableState) => tableState.perPage
);

export const getIngredientsOrder = createSelector(
  getIngredientsTableState,
  (tableState) => tableState.order
);

export const getIngredientsDirection = createSelector(
  getIngredientsTableState,
  (tableState) => tableState.direction
);

export const getFilters = createSelector(
  getIngredientsTableState,
  (tableState) => tableState.filters
);

export const getIngredientsDialogId = createSelector(
  selectIngredientState,
  (state: IngredientState) => state.dialogId
);

export const getSelectedIngredient = createSelector(
  selectIngredientState,
  (state: IngredientState) => state.ingredients
);
export const getSelectionDialogId = createSelector(
  selectIngredientState,
  (state: IngredientState) => state.selectionDialogId
);

export const getSelectedIngredients = createSelector(
  selectIngredientState,
  (state: IngredientState) => state.selectedIngredients
);

export const getSelectedIngredientsCurrentPage = createSelector(
  selectIngredientState,
  (state: IngredientState) => {
    //console.log("Stato ingredienti in store:", state);
    const selectedIds = (state.selectedIngredients || []).map(bl => bl.id);
    return state.list?.filter(bl => selectedIds.includes(bl.id));
  }
);